export { commentAPI } from './commentAPI';
